import type { IconProps } from './IconProps';

export const CurrencyDollarCircleIcon = (props: IconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 16 16"
    fill="none"
    width={props.width ?? 16}
    height={props.height ?? 16}
    {...props}
  >
    <g clipPath="url(#clip0_3012_90845)">
      <path
        d="M5.66659 9.77745C5.66659 10.6366 6.36303 11.333 7.22214 11.333H8.66658C9.58706 11.333 10.3333 10.5868 10.3333 9.66634C10.3333 8.74587 9.58706 7.99967 8.66658 7.99967H7.33325C6.41278 7.99967 5.66659 7.25348 5.66659 6.33301C5.66659 5.41253 6.41278 4.66634 7.33325 4.66634H8.7777C9.63681 4.66634 10.3333 5.36279 10.3333 6.2219M7.99992 3.66634V4.66634M7.99992 11.333V12.333M14.6666 7.99967C14.6666 11.6816 11.6818 14.6663 7.99992 14.6663C4.31802 14.6663 1.33325 11.6816 1.33325 7.99967C1.33325 4.31778 4.31802 1.33301 7.99992 1.33301C11.6818 1.33301 14.6666 4.31778 14.6666 7.99967Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_3012_90845">
        <rect width="16" height="16" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
